"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function ConsultingPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return;
}